if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.bundleOptionsForm = document.querySelector('form#bundle_options');

        if (this.bundleOptionsForm) {
          this.bundleOptionsForm.productForm = this;
          this.customSelects = document.querySelectorAll('.variants-select .custom-select select, .select__select');
          this.onBundleOptionsChangeHandler = this.onBundleOptionsChangeHandler.bind(this.bundleOptionsForm);
          this.bundleOptionsForm.addEventListener('change', this.onBundleOptionsChangeHandler);
          this.customSelects.forEach(el => el.addEventListener('change', () => { setTimeout(this.onBundleOptionsChangeHandler, 500) }));
          this.onBundleOptionsChangeHandler();
        }
      }

      onBundleOptionsChangeHandler(evt) {
        const dropdown = document.querySelector('.variants-select .custom-select select');
        if(dropdown){
        const selectedOption = dropdown.options[dropdown.selectedIndex];
        const dropdownSizeOptions = document.querySelectorAll('.dropdownSizeOptions');
        dropdownSizeOptions.forEach(element => {
            element.classList.add('hidden');
        });
        if(selectedOption.hasAttribute("data-dropdownid")){
          var dropdownid = selectedOption.getAttribute("data-dropdownid");
          var dropdownoption = document.getElementById(dropdownid);
          dropdownoption.classList.remove('hidden');
        }
        }
        const regularPriceElement = document.querySelector(".price-item.price-item--regular");
        const initialPrice = parseInt(regularPriceElement.dataset.initialPrice);
        const inputsWithVariant = Array.from(this.querySelectorAll("[data-variant-id]:is(:selected, :checked)")).filter(input => input.dataset.variantId);

        this.variantIds = inputsWithVariant.map(input => parseInt(input.dataset.variantId));
        this.price = initialPrice + inputsWithVariant.map(input => input.dataset.price).reduce((a, b) => (parseInt(a) || 0) + (parseInt(b) || 0), 0);

        regularPriceElement.innerText = Shopify.formatMoney(this.price);
      }

      updateInsurance(updatedItems) {

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (typeof validateVariants === "function") {
        if (!validateVariants()){
          return;
        }
        }else{
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.bundleOptionsForm && !this.bundleOptionsForm.checkValidity()) {
          this.bundleOptionsForm.reportValidity();
          return;
        }
        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const { id, quantity } = Object.fromEntries(new FormData(this.form).entries());
        var varids = document.getElementById('var-' + id);
        if (varids) {
          if (typeof addVariantsToCart === "function") {
          addVariantsToCart(varids.value)
          return;
          }
        }
        const dropdown = document.querySelector('.variants-select .custom-select select');
        if(dropdown){
        const selectedOption = dropdown.options[dropdown.selectedIndex];
        if(selectedOption.hasAttribute("data-dropdownid")){
          //var dropdownid = selectedOption.getAttribute("data-dropdownid");
          var rangeVariant = shocksCalculator(id);
          if(rangeVariant == 'empty'){
            modal.style.display = "block";
            return;
          }
          else if(rangeVariant == ''){
            var field1 = document.getElementById('calc_field1');
            var field2 = document.getElementById('calc_field2');
            document.getElementById('field1range').value = field1.value;
            document.getElementById('field2range').value = field2.value;
            document.getElementById('contactModal').style.display = 'block';
            return;
          }
          else{
            if (typeof addVariantsToCart === "function") {
            addVariantsToCart(rangeVariant);
            return;
            }
          }
          /*var dropdownoption = document.getElementById("custproductsize_" + id);
          var selecteddropoption = dropdownoption.options[dropdownoption.selectedIndex];
          if(selecteddropoption.value){
            addVariantsToCart(selecteddropoption.value);
            return;
          }
          else{
            modal.style.display = "block";
            return;
          }*/
          
        }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden',
        );
        
        const mainItem = { id: parseInt(id), quantity: parseInt(quantity), properties: {} };
        var formData = new FormData(this.form);

  if (!mainItem.properties) {
      mainItem.properties = {};
    }
          
        var dropdowns = document.querySelectorAll('select[data-dropdown-properties]');

        dropdowns.forEach(function(dropdown) {
            var name = dropdown.name.slice(11, -1); // Extract the name without 'properties[' and ']'
            var selectedOption = dropdown.options[dropdown.selectedIndex];
            var value = selectedOption.value.trim();
            if (value === 'empty') {
                value = selectedOption.text;
            }
            mainItem.properties[name] = value;
        });
        const items = [mainItem];

        /*if (this.bundleOptionsForm) {
          const properties = Object.fromEntries(new FormData(this.bundleOptionsForm).entries());

          properties._bundle_variant_ids = JSON.stringify(this.bundleOptionsForm.variantIds);
          properties._bundle_price = this.bundleOptionsForm.price;
          var orderType = document.getElementById('order-type');
          if (orderType) {
            properties["Order Type"] = orderType.value;
          }
          else{
            var orderTypeVariant = document.getElementById('order-type-' + id);
            if (orderTypeVariant) {
              properties["Order Type"] = orderTypeVariant.value;
            }
          }

          mainItem.properties = properties;

          this.bundleOptionsForm.variantIds.forEach(variant_id => {
            items.push({
              id: parseInt(variant_id),
              quantity: parseInt(quantity),
            }) 
          });
        }*/

        
        
        //this.cart.currentItems = JSON.parse(this.cart.querySelector('cart-drawer-items').dataset.items).filter(item => item.id != id)
        //let insuranceLineItem = this.cart.currentItems.filter(item => item.id == shippingInsuranceVariantId);

        
        
        const payload = { items };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        config.body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async(response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              addVariantsToCart("");
              //window.location = window.routes.cart_url;
              return;
            }
            
            if(null == response.sections) {
              const sections = await fetch(`${routes.cart_url}?sections=${this.cart.getSectionsToRender().map(section => section.id)}`)
              response.sections = await sections.json()
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.currentItems = JSON.parse(this.cart.querySelector('cart-items').dataset.items).filter(item => item.id != id)
              let insuranceLineItem = this.cart.currentItems.filter(item => item.id == shippingInsuranceVariantId);
              if(insuranceLineItem.length) {
                const updatedItems = [...this.cart.currentItems, ...response.items];
                
                const price = updatedItems.map(citem => {
                  if(shippingInsuranceVariantId == citem.id) {
                    citem.line_price = 0;
                  }
                    
                  return parseFloat(citem.line_price) / 100
                }).reduce((a, b) => a + b, 0.0);

                const shippingInsurancePrice = (price * (shippingInsurancePercentage / 100)).toFixed(2);

                let updatesArray = [...this.cart.currentItems, ...response.items].map((item) => {
                  if(item.id == shippingInsuranceVariantId) {
                    if (shippingInsurancePrice > 0) {
                      item.quantity = parseInt(shippingInsurancePrice * 100)
                    } else {
                      item.quantity = 0
                    }
                  }
                  
                  return {
                    [item.key]: item.quantity
                  }
                });

                var updates = updatesArray.reduce(function(map, obj) {
                    map[Object.keys(obj)[0]] = Object.values(obj)[0];
                    return map;
                }, {});

                const body = JSON.stringify({
                  updates,
                  sections: this.cart.getSectionsToRender().map((section) => section.id),
                  sections_url: window.location.pathname,
                });
                
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                  .then((response) => {
                    return response.text();
                  })
                  .then((state) => {
                    const parsedState = JSON.parse(state);
                    console.log('parsedState', parsedState)
                    this.cart.renderContents(parsedState);
                  });
              } else {
                await this.cart.renderContents(response);
                // let shippingInsuranceInput = document.querySelector('input[name="shipping_insurance_radio"]:checked').value;
                // if((shippingInsuranceInput == "no") && this.cart.currentItems.length == 0) {
                //   document.querySelector('#shipping_insurance_radio_yes').click()
                // }
                // let shippingInsuranceInput = document.querySelector('#shipping_insurance_checkbox');
                // if(!shippingInsuranceInput.checked && this.cart.currentItems.length == 0) {
                //   shippingInsuranceInput.click()
                // }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}